import { render, staticRenderFns } from "./BuildLogs.vue?vue&type=template&id=4a666073&"
import script from "./BuildLogs.vue?vue&type=script&lang=js&"
export * from "./BuildLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports